import { AgentModals } from '../../agent/AgentModals'
import _ from 'lodash'
import { store } from '../../../store/store'
import { splitAdvertiseLinks, normalizeLinkStatus, getPortalLabel, getLinkComment, getLinkDisabled } from '../../agent/advertises/portalLinks'

const magicFillCheckLinks = (advertiseID: number, modalID: string): { modal: Record<string, unknown> } => {
    const modal = _.cloneDeep(
        _.find(AgentModals(),
            (modal: any) => modal.id === modalID
        )
    )
    const advertise = _.find(
        store.getState().advertises.advertises,
        (advertise: any) => advertise.id === advertiseID
    )
    if (advertise?.attributes.Links != null && modalID === 'check_advertisement_links_modal') {
        const { trakheesi, portals } = splitAdvertiseLinks(advertise?.attributes?.Links)
        const trakheesiRows = _.map(trakheesi, (link: any) => (
            {
                id: `Links[${link.__sourceIndex}].Status`,
                content: [link?.Trakheesi_id ?? '-', 'Trakheesi', link?.Trakheesi_id ?? '-'],
                default: normalizeLinkStatus(link?.Status) === 'Approved',
                element: 'check-link'
            }
        ))
        const portalRows = _.map(portals, (link: any, index) => (
            {
                id: `PortalLinksReview[${index}]`,
                content: [
                    getPortalLabel(link),
                    link?.Link ?? '#'
                ],
                element: 'check-link-portal',
                sourceIndex: link.__sourceIndex,
                defaultPortal: link?.Portal ?? link?.Title ?? '',
                defaultLink: link?.Link ?? '',
                defaultStatus: normalizeLinkStatus(link?.Status),
                defaultComment: getLinkComment(link),
                defaultDisabled: getLinkDisabled(link)
            }
        ))
        const sharedRows: any[] = []

        if (trakheesiRows.length > 0) {
            sharedRows.push(
                {
                    id: 'trakheesi_links_title',
                    content: ['Trakheesi IDs Review'],
                    element: 'label-primary'
                },
                ...trakheesiRows
            )
        }

        if (portalRows.length > 0) {
            sharedRows.push(
                {
                    id: 'portal_links_title',
                    content: ['Portal Links Review'],
                    element: 'label-primary'
                },
                ...portalRows
            )
        }

        modal.header = portals.length > 0 ? 'Check Advertisement Links' : 'Check Advertisement Trakheesi ID'
        modal.form = [
            ...sharedRows,
            ...modal.form
        ]

        const rejectReasonRow = modal.form.find((row: any) => row?.id === 'RejectReason')
        if (rejectReasonRow != null) {
            rejectReasonRow.content = ['Reject reason / admin comment', '']
        }
    } else if (advertise?.attributes.Links != null) {
        const linkRows = _.map(advertise?.attributes.Links, (link: any, index) => (
            {
                id: `Links[${index}].Status`,
                content: [link.Trakheesi_id, link.Title, link.Trakheesi_id],
                default: link.Status === 'Approved',
                element: 'check-link'
            }
        ))
        modal.form = [
            ...linkRows,
            ...modal.form
        ]
    }
    return {
        modal
    }
}

export default magicFillCheckLinks
